import IconCopy from '@apollo/icons/default/IconCopy.svg';
import { IconButton, Text } from '@apollo/orbit';
import copy from 'copy-to-clipboard';
import React from 'react';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';

interface Props {
  operationId: string;
}

export const OperationIdSection = ({ operationId }: Props) => {
  return (
    <Tooltip label="Copy" clickedLabel="Copied" placement="right">
      <div
        className="group flex max-w-max cursor-pointer items-center"
        onClick={() => copy(operationId)}
      >
        <Text className="min-w-20 truncate" variant="code">
          {operationId}
        </Text>
        <IconButton
          size="xs"
          className="invisible ml-1 group-hover:visible"
          icon={<IconCopy />}
          variant="hidden"
          aria-label="Copy"
        />
      </div>
    </Tooltip>
  );
};
